import { urls } from 'config/constants';

/** Resources links in: Header More Menu (Desktop), More Page (Mobile) */
export const resourcesLinks = [
  {
    label: 'API Docs',
    to: urls.apiDocs,
  },
  {
    label: 'API Keys',
    to: '/wallet/api-keys',
  },
  {
    label: 'Docs',
    to: urls.katanaDocs,
  },
  {
    label: 'Legal',
    to: '/legal',
  },
];
